import { Dispatch } from 'redux';
import { Services } from '../../types/services';

const SET_SITE_UPDATE_COUNTS = 'SET_SITE_UPDATE_COUNTS';
const SET_SITE_UPDATES = 'SET_SITE_UPDATES';

interface Update {
  id?: string;
  [key: string]: unknown;
}

interface State {
  updateCount: number;
  updates: Update[];
}

const initialState: State = {
  updateCount: 0,
  updates: [],
};

interface Action {
  type: typeof SET_SITE_UPDATE_COUNTS | typeof SET_SITE_UPDATES;
  payload?: number | Update[];
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case SET_SITE_UPDATE_COUNTS:
      return {
        ...state,
        updateCount: action.payload as number,
      };
    case SET_SITE_UPDATES:
      return {
        ...state,
        updates: action.payload as Update[],
      };
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosService = services.axios.Axios();

  const setUpdateCounts = (count: number) => {
    return {
      type: SET_SITE_UPDATE_COUNTS,
      payload: count,
    };
  };

  const fetchUpdateCounts = () => {
    return async (dispatch: Dispatch) => {
      try {
        const response = await axiosService.get<{ data: number }>(`meta/updates`);
        dispatch(setUpdateCounts(response.data.data));
      } catch (err) {
        console.error(err);
      }
    };
  };

  const setUpdates = (updates: Update[]) => {
    return {
      type: SET_SITE_UPDATES,
      payload: updates,
    };
  };

  const fetchUpdates = () => {
    return async (dispatch: Dispatch) => {
      try {
        const response = await axiosService.get<{ data: Update[] }>(`meta/updates/list`);
        dispatch(setUpdates(response.data.data));
      } catch (err) {
        console.error(err);
      }
    };
  };

  return {
    fetchUpdateCounts,
    fetchUpdates,
  };
};

